<!--
 * @Description: wap app.vue
 * @Author: Rfan
 * @Date: 2020-01-14 11:45:20
 * @LastEditTime: 2023-11-16 15:32:01
--> 
<template>
  <div id="app" oncontextmenu="self.event.returnValue=false">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" ref="view" :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" ref="view" :key="key"></router-view>
    <!-- <router-view /> -->
    <!-- <keep-alive :include="cachedViews">
      <router-view :key="key" />
    </keep-alive> -->
  </div>
</template>

<script>
import {
  getUserInfo,
  getAppVerInfo,
  setupWebViewJavascriptBridge,
  getBindInfo,
} from "@/assets/js/client.js";
import { testPlatform } from "@/utils";

export default {
  name: "app",
  data() {
    return {
      loadCount: 0,
    };
  },
  computed: {
    // key() {
    //   return this.$route.name + new Date().getTime();
    // },
    key() {
      return this.$route.path;
    }
  },
  created() {
    setTimeout(() => {
      getBindInfo();
    }, 200);
    this.fetchInfoFromAPP();
  },
  methods: {
    fetchInfoFromAPP() {
      let that = this;
      if (testPlatform("ios")) {
        setupWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler("getCurrentUserToken", null, function (data) {
            that.$store.commit("setMemberInfo", data);
            that.$store.commit("setQuery", data);
            console.log("app memberinfo", data);
            getBindInfo();
          });
          bridge.callHandler("getAppVer", null, function (data) {
            that.$store.commit("setVer", data);
            try {
              console.log("app ver", data, parseInt(data.replace(/\./g, "")));
            } catch (err) {
              console.log(err);
            }
          });
        });
      } else {
        this.androidMethod();
      }
    },
    androidMethod() {
      console.log("create count:", this.loadCount);
      if (window.hsj) {
        let _userInfo = getUserInfo();
        let _version = getAppVerInfo();
        console.log("android _userInfo", typeof _userInfo, _userInfo);
        console.log("android _version", typeof _version, _version);
        if (_version) {
          let info = JSON.parse(_userInfo);
          let ver = JSON.parse(_version);
          console.log("next app", info, ver);
          this.$store.commit("setMemberInfo", info);
          this.$store.commit("setQuery", info);
          this.$store.commit("setVer", ver); // "verCode":89,"verName":"1.6.2"
        }
      } else {
        if (this.loadCount < 5) {
          setTimeout(() => {
            this.loadCount++;
            this.androidMethod();
            console.log("load times", this.loadCount);
          }, 200);
        }
      }
    },
    userInfoCb(_userInfo) {
      let info = JSON.parse(_userInfo);
      console.log("userInfoCb", info);
      this.$store.commit("setMemberInfo", info);
      this.$store.commit("setQuery", info);
      getBindInfo();
    },
    versionCb(_version) {
      console.log("versionCb org", _version);
      let ver = JSON.parse(_version);
      console.log("versionCb", ver);
      this.$store.commit("setVer", ver); // "verCode":89,"verName":"1.6.2"
    },
  },
};
</script>

<style>
</style>
